module.exports = __webpack_public_path__ + "img/04.cb132f20.png";